import * as React from "react";
import { Block } from "kanopi-components/Block";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import { StyledLink } from "kanopi-components/Link/StyledLink";

interface IDisclaimerLinksProps {
  links: {
    name: string;
    url: string;
  }[];
}

export const DisclaimerLinks: React.FC<IDisclaimerLinksProps> = ({ links }) => {
  const [css, theme] = useStyletron();

  return (
    <Block display="flex" justifyContent="center">
      <ul
        style={{
          listStyle: "none",
          display: "flex",
          padding: 0,
          margin: 0,
        }}
      >
        {links.map((link, index) => (
          <li
            className={css({
              ":not(:last-child)": {
                borderRight: "1px solid",
              },
              padding: `0 ${theme.sizing.scale400} 0`,
              lineHeight: theme.typography.font100.fontSize,
            })}
            key={index}
          >
            <StyledLink
              href={link.url}
              style={{
                color: theme.colors.mono700,
                textDecoration: "none",
                ":hover": {
                  textDecoration: "none",
                },
                fontSize: theme.typography.font100.fontSize,
              }}
            >
              {link.name}
            </StyledLink>
          </li>
        ))}
      </ul>
    </Block>
  );
};
